import { render } from "./TbTd.vue?vue&type=template&id=761f0856"
import script from "./TbTd.vue?vue&type=script&lang=js"
export * from "./TbTd.vue?vue&type=script&lang=js"
script.render = render

export default script